import _ from 'lodash';
import assetTypeCategoryApi from '@/api/assetTypeCategoryApi';
import { fetchOnce } from '@/store/utils/fetchOnce';

export default {
	namespace: true,

	state: {
		assetTypeCategories: {},
		assetTypeCategoriesLoaded: false
	},

	mutations: {
		SET_ALL_ASSET_TYPE_CATEGORIES(state, assetTypeCategories) {
			state.assetTypeCategories = assetTypeCategories;
		},
		SET_ASSET_TYPE_CATEGORIES_LOADED(state, val) {
			state.assetTypeCategoriesLoaded = val;
		}
	},

	actions: {
		setAllAssetTypeCategories(vuexContext, assetTypeCategories) {
			vuexContext.commit('SET_ALL_ASSET_TYPE_CATEGORIES', assetTypeCategories);
		},
		fetchAssetTypeCategoriesIfNeeded({ state, commit }, { currUserId }) {
			if (state.assetTypeCategoriesLoaded) return Promise.resolve();
			return fetchOnce('assetTypeCategories', () =>
				assetTypeCategoryApi.getAssetTypeCategories(currUserId).then(({ data }) => {
					if (data.isSuccess) {
						commit('SET_ALL_ASSET_TYPE_CATEGORIES', data.assetTypeCategories);
						commit('SET_ASSET_TYPE_CATEGORIES_LOADED', true);
					}
					return data;
				})
			);
		}
	},

	getters: {
		assetTypeCategories(state) {
			if (!_.isEmpty(state.assetTypeCategories)) {
				return state.assetTypeCategories;
			}
			return {};
		},
	}
}
